import React from "react";
import { FunctionComponent } from "react";
import { Button } from "react-bootstrap";
import classNames from "classnames";

export interface ButtonProps {
    label: string | JSX.Element;
    onClick: () => void;
    disable?: boolean;
}

interface CommonModalFooterControlsProps {
    primary?: ButtonProps;
    secondary?: ButtonProps;
    cancel?: ButtonProps;
}

const CommonModalFooterControls: FunctionComponent<CommonModalFooterControlsProps> = props => {
    const primaryButton = props.primary ? makeButton("primary", props.primary) : null;
    const secondaryButton = props.secondary ? makeButton("secondary", props.secondary) : null;
    const cancelButton = props.cancel ? makeButton("link", props.cancel, "btn-cancel") : null;

    return (
        <React.Fragment>
            {primaryButton}
            {secondaryButton}
            {cancelButton}
        </React.Fragment>
    );
};

function makeButton(
    variant: "primary" | "secondary" | "link",
    props: ButtonProps,
    additionalClasses?: string
): JSX.Element {
    return (
        <Button
            variant={variant}
            className={classNames({ disabled: props.disable }, additionalClasses)}
            onClick={props.onClick}
            disabled={props.disable}
            data-testid={`modal-footer-button-${variant}`}
        >
            {props.label}
        </Button>
    );
}

export default CommonModalFooterControls;
